export enum ExperiencePricingModel {
  Free = 'free',
  Flat = 'flat',
  Range = 'range'
}
